import { GET_CONTACT_US_INFO, CONTACT_US_INFO_ERROR } from "../types";

const initialState = {
  contactUsInfo: {},
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_CONTACT_US_INFO:
      return {
        ...state,
        contactUsInfo: action.payload,
        loading: false,
      };
    case CONTACT_US_INFO_ERROR:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
}
